/** @jsx jsx */
import { jsx } from 'theme-ui';
import DefaultFacet from '../DefaultFacet/DefaultFacet';
import { Trans } from '@lingui/macro';

export default function ProductDistributionInMarketFacet({
  allValues,
  selectedValues,
  onToggle,
  totalCount,
  count,
  ...rest
}) {
  return (
    <DefaultFacet
      title={<Trans>Distribution in Market</Trans>}
      allValues={allValues}
      selectedValues={selectedValues}
      onToggle={onToggle}
      totalCount={totalCount}
      count={count}
      {...rest}
    />
  );
}
